export default {
  tabsBarLabel: {
    id: 'listing_detail_tabs_bar_label',
    defaultMessage: 'Listing detail navigation',
  },
  alertsTabLabel: {
    id: 'listing_detail_alert_tab',
    defaultMessage: 'Alerts',
  },
  commentsTabLabel: {
    id: 'listing_detail_comment_tab',
    defaultMessage: 'Comments',
  },
  shippingTabLabel: {
    id: 'listing_detail_shipping_tab',
    defaultMessage: 'Shipping method',
  },
  pricingInsightsTabLabel: {
    id: 'bo_seller.listings.listing_detail.pricing_insights_tab',
    defaultMessage: 'Pricing Insights',
  },
  listingDetail: {
    id: 'listings_detail',
    defaultMessage: 'Listing detail',
  },
  productSpecificationsTabLabel: {
    id: 'listings_detail_item_specifications',
    defaultMessage: 'Item Specifications',
  },
  similarListingsTabLabel: {
    id: 'listings_detail_similar_listings',
    defaultMessage: 'Similar Listings',
  },
  loadingText: {
    id: 'listings_detail_loading_text',
    defaultMessage: 'Loading listing info...',
  },
  listingNotFound: {
    id: 'bo_seller.listings.detail.listing_not_found',
    defaultMessage: 'Listing not found',
  },
}
